import type { ExtractPropTypes, PropType } from 'vue';
import type IconSelect from './icon-select.vue';

type IconSelectType = 'input' | 'card';

export const IconSelectProps = {
  type: {
    type: String as PropType<IconSelectType>,
    default: 'input',
  },
  modelValue: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '100px',
  },
};

export type IconSelectPropsType = ExtractPropTypes<typeof IconSelectProps>;
export type IconSelectInstance = InstanceType<typeof IconSelect>;
